export const FAQ_BLOCK_COPY = 'block';
export const FAQ_CONTENT_BLOCK_COPY = 'contentBlock';
